import { getImageSrc } from '../../../../utilites/util';

const BankCardsImages: React.FC<any> = () => {
  const visa = getImageSrc('bank/', 'paymentinfo-visa', 'png');
  const verifiedVisa = getImageSrc('bank/', 'paymentinfo-verified-visa', 'png');
  const maestrocard = getImageSrc('bank/', 'paymentinfo-maestro', 'png');
  const mastercard = getImageSrc('bank/', 'paymentinfo-master', 'png');
  const dinaCard = getImageSrc('bank/', 'paymentinfo-dina', 'png');
  const secureCodeMaster = getImageSrc('bank/', 'paymentinfo-securecode-master', 'png');
  return (
    <>
      <div className="text-center mb-3">
        <img src={visa} alt={'visa'} />
        <img src={mastercard} alt="master" />
        <img src={maestrocard} alt="maestro" />
        <img src={dinaCard} alt="dinaCard" />
      </div>

      <div className="text-center mb-5">
        <a href="https://www.visa.ca/verified/infopane/index.html">
          <img className={'me-4'} src={verifiedVisa} alt="verified visa" />
        </a>
        <a href="https://www.mastercardbusiness.com/mcbiz/index.jsp?template=/orphans&amp;content=securecodepopup">
          <img src={secureCodeMaster} alt="secure code master" />
        </a>
      </div>
    </>
  );
};

export default BankCardsImages;
